/*
 * This file is part of pastyclient
 *
 * Copyright 2021 Philipp Geschke
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 *
 * Implements Pasty API version 3
 */

var apiBaseUrl = 'https://api.pastyapp.org'
const apiVersion = '3.0.0'

export async function getJwt(credentials) {
  let headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Accept-Version', apiVersion)
  headers = setAuthorizationHeader(credentials, headers)
  const url = `${apiBaseUrl}/jwt`

  const res = await fetch(url, {
    method: 'POST',
    headers
  })
  if (res.ok) {
    const accessToken = res.json()
    return accessToken
  } else {
    throw await handleError(res)
  }
}

export async function refreshJwt(refreshToken, username) {
  let headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Accept-Version', apiVersion)
  headers = setAuthorizationHeader({ accessToken: refreshToken }, headers)
  const url = `${apiBaseUrl}/jwt/refresh`

  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ username })
  })
  if (res.ok) {
    const accessToken = res.json()
    return accessToken
  } else {
    throw await handleError(res)
  }
}

export async function getClipboard(credentials) {
  let headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Accept-Version', apiVersion)
  headers = setAuthorizationHeader(credentials, headers)
  const url = `${apiBaseUrl}/clipboard/list.json`
  const res = await fetch(url, {
    headers
   })
  if (res.ok) {
    const jsonData = await res.json()
    return jsonData
  } else {
    throw await handleError(res)
  }
}

export async function addItem(item, credentials) {
  if (item === null || item === undefined || item === '') throw new Error('Empty item')

  let headers = new Headers();
  headers.append('Content-Type', 'application/json')
  headers.append('Accept-Version', apiVersion)
  headers = setAuthorizationHeader(credentials, headers)
  const url = `${apiBaseUrl}/clipboard/item`
  const res = await fetch(url, {
  headers,
  method: 'POST',
  body: JSON.stringify({ item })
  })
  if (res.ok) {
    const jsonData = await res.json()
    return jsonData
  } else {
    throw await handleError(res)
  }
}

export async function delItem(id, credentials) {
  if (id === null || id === undefined || id === '') throw new Error('Empty id')

  let headers = new Headers();
  headers.append('Content-Type', 'application/json')
  headers.append('Accept-Version', apiVersion)
  headers = setAuthorizationHeader(credentials, headers)
  const url = `${apiBaseUrl}/clipboard/item/${id}`
  const res = await fetch(url, {
    headers,
    method: 'DELETE'
  })
  if (res.ok) {
    return true
  } else {
    throw await handleError(res)
  }
}

 export function setApiBaseUrl(url) {
   apiBaseUrl = url
 }

const setAuthorizationHeader = (credentials, headers) => {
  if (undefined === headers) throw new Error('Missing headers')
  if (undefined === credentials) throw new Error('Missing credentials')
  if (credentials.accessToken === undefined &&
    (credentials.username === undefined || credentials.password === undefined)) {
    throw new Error('Need accessToken or username and password')
  }
  if (credentials.accessToken !== undefined) {
    headers.append('Authorization', 'Bearer ' + credentials.accessToken)
  } else {
    headers.append('Authorization', 'Basic ' + btoa(credentials.username + ':' + credentials.password))
  }
  return headers
}

const handleError = async res => {
  // try and see if there is a json error
  try {
    const jsonErr = await res.json()
    if (jsonErr.error.message !== undefined) {
      return new Error(jsonErr.error.message)
    }
  } catch (err) {
    if (res.status === 401) {
      return new Error('Invalid login credentials')
    } else {
      return new Error('Unknown error occured')
    }
  }
}

onmessage = function(e) {
  console.dir(e)
}

export default {
 getJwt,
 setApiBaseUrl,
 getClipboard,
 addItem,
 delItem
}
